module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0135.jpg?v=0b57caea";